import React, { useState, useEffect } from 'react';
import './hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97",
      title: "Welcome to Nice Computer Education",
      subtitle: "Empowering futures through quality computer education"
    },
    {
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3",
      title: "Learn from the Best",
      subtitle: "Industry experts & cutting-edge curriculum"
    },
    {
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa",
      title: "Build Your Future",
      subtitle: "Practical skills for the digital age"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => 
        prevSlide === slides.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const openPDF = () => {
    window.open(`${process.env.PUBLIC_URL}/CourseInfo.pdf`, '_blank');
  };

  return (
    <section className="hero" id="home">
      <div className="carousel">
        {slides.map((slide, index) => (
          <div 
            key={index} 
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="slide-content">
              <h1>{slide.title}</h1>
              <p>{slide.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>

      <div className="hero-content">
        <button className="cta-button" onClick={openPDF}>
          Explore Courses
        </button>
      </div>
    </section>
  );
};

export default Hero;
